import styled from 'styled-components/macro';
import Banner from '../Banner';
import BannerContent from '../BannerContent';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

export const StyledBanner = styled(Banner)`
  ${fontSize(38)};
  ${media.desktop`
    ${fontSize(48)};
    padding: 10 0;
  `}
`;

export const StyledBannerContent = styled(BannerContent)`
  h2 {
    margin-bottom: 10px;
    ${media.desktop`
        margin-bottom: 0;
    `}
  }

  p {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    small {
      width: 100%;
      text-align: center;
      ${media.desktop`
        width: auto;
        line-height: 4;
      `}
    }

    ${media.desktop`
    `}
    font-weight: bold;
    ${media.desktop`
    margin-left: 15px;
  `}
    small {
      font-weight: normal;
      ${fontSize(14)};
      ${media.desktop`
        ${fontSize(16)};
      `}
    }
    strong {
      ${fontSize(38)};
      ${media.desktop`
        ${fontSize(48)};
      `}
    }
  }
  justify-content: center;
  ${media.desktop`
    flex-direction: row;
    justify-content: center;
    align-items: baseline;
  `};
`;
